import Vue from 'vue'
import App from './components/bbrf/App.vue'
import router from './router'
import VueMoment from 'vue-moment'
import moment from 'moment'

import VueClipboard from 'vue-clipboard2'
import { BootstrapVueIcons, ModalPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(VueClipboard)
Vue.use(BootstrapVueIcons)
Vue.use(ModalPlugin)

Vue.use(VueMoment, { moment })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')